import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { Config } from 'src/app/services/env.config';
import { AbmPopupComponent } from '../abm-popup/abm-popup.component';
import { DdPopupComponent } from '../dd-popup/dd-popup.component';
import { IddPopupComponent } from '../idd-popup/idd-popup.component';
import { ReportsService } from '../reports.service';
import { RsPopupComponent } from '../rs-popup/rs-popup.component';

@Component({
  selector: 'app-rs-dashboard',
  templateUrl: './rs-dashboard.component.html',
  styleUrls: ['./rs-dashboard.component.scss']
})
export class RsDashboardComponent implements OnInit {

  constructor(public reportsService: ReportsService, private modalService: MDBModalService) { 
    this.fromDateValue.setDate(this.fromDateValue.getDate() - 30);
   this.fromDateValue =  moment(this.fromDateValue).format('YYYY-MM-DD');
  }
  fromDate: any = '01-01-2022';
  toDate: any = '31-01-2022';
  toDateValue = moment(new Date()).format('YYYY-MM-DD');
  fromDateValue: any = new Date(); 
  MaxToDate :any  = moment(new Date()).format('YYYY-MM-DD');
  today = moment(new Date()).format('YYYY-MM-DD'); 
  tableData :any[] = [];
  abmTable :any[] = [];
  rsmTable :any[] = [];
  ngOnInit() {
    this.getDashboardReport();
  }

  onDateChange(event) {
    console.log("from", this.fromDateValue);
    console.log("to", this.toDateValue);
    let date = new Date(this.fromDateValue);
    date.setDate(date.getDate() + 30);
    this.MaxToDate =  moment(date).format('YYYY-MM-DD');
    this.toDateValue = moment(date).format('YYYY-MM-DD');
    // this.getReports();
  }

  getDashboardReport() {
      this.reportsService.getDashboardReportABM(this.fromDateValue, this.toDateValue).then((data: any) => {
         this.tableData = data;
         }, errorCode => console.log(errorCode));
  }


  schemeModalRef: MDBModalRef;
  openIDdPopup(code) {
    console.log("code");
    console.log(code);
    let data = {FromDate : this.fromDateValue, ToDate : this.toDateValue, code: code}
    this.schemeModalRef = this.modalService.show(IddPopupComponent, {
      data: {
        message: '',
        data: data
      }, class:  'modal-md', backdrop: 'static'
    });
    this.schemeModalRef.content.action.subscribe((result: any) => {
      if (result == 'OK') {
            this.schemeModalRef.hide();
      }
    });
  }


  openAbmPopup(code) {
    console.log("code");
    console.log(code);
    let data = {FromDate : this.fromDateValue, ToDate : this.toDateValue,  code: code}
    this.schemeModalRef = this.modalService.show(AbmPopupComponent, {
      data: {
        message: '',
        data: data
      }, class:  'modal-md', backdrop: 'static'
    });
    this.schemeModalRef.content.action.subscribe((result: any) => {
      if (result == 'OK') {
            this.schemeModalRef.hide();
      }
    });
  }


  openRsPopup(code) {
    console.log("code");
    console.log(code);
    let data = {FromDate : this.fromDateValue, ToDate : this.toDateValue, code: code}
    this.schemeModalRef = this.modalService.show(RsPopupComponent, {
      data: {
        message: '',
        data: data
      }, class:  'modal-lg', backdrop: 'static'
    });
    this.schemeModalRef.content.action.subscribe((result: any) => {
      if (result == 'OK') {
            this.schemeModalRef.hide();
      }
    });
  }

  
}

